// extracted by mini-css-extract-plugin
export default {"styledParagraph":"SanitizedReactHtmlParser_styledParagraph__Xtt1u"};